import { AppStoreState } from '../interfaces/app-store-state';
import {createFeatureSelector, createSelector} from "@ngrx/store";

const selectAppState = createFeatureSelector<AppStoreState>('app');
export const selectCommonData = (state: {app: AppStoreState}) => state.app.commonData;
export const selectPageTitle = (state: {app: AppStoreState}) => state.app.pageTitle;

export const selectInstanceId = createSelector(
  selectAppState,
  state => state.commonData?.user?.instance_id
);

export const selectCurrentUser = createSelector(
  selectAppState,
  state => state.commonData?.user
);

export const selectCurrentUserInfo = createSelector(
  selectAppState,
  state => state.commonData?.user_info
);

export const selectOrgId = createSelector(
  selectAppState,
  state => state.commonData?.user?.org_id
);

export const selectCrmId = createSelector(
  selectAppState,
  state => state.commonData?.user?.crm_id
);
